export const voices = ["alloy", "echo", "fable", "onyx", "nova", "shimmer"];
export const models = ["tts-1", "tts-1-hd"];
export const formats = ["mp3", "opus", "aac", "flac"];
